import orbBlue from '@/assets/orbs/blue.jpg';
import orbGreen from '@/assets/orbs/green.jpg';
import orbPurple from '@/assets/orbs/purple.jpg';
import orbRed from '@/assets/orbs/red.jpg';
import orbOrange from '@/assets/orbs/orange.jpg';

/**
 * HeroUI avatar recipes. The glossy "orb" avatars are HeroUI's own demo
 * images (heroui-assets …/avatars/{blue,green,purple,red,orange}.jpg),
 * vendored locally so we don't depend on their CDN and stay offline. We
 * pick one deterministically per id so users without a photo get a stable,
 * varied orb instead of a flat fallback.
 */

// Avatar → "Custom Styles": gradient border/ring (verbatim from MCP docs).
export const HERO_AVATAR_RING = 'rounded-full bg-gradient-to-tr from-pink-500 to-yellow-500 p-0.5';
export const HERO_AVATAR_RING_INNER = 'size-full rounded-full bg-background p-0.5';

// Last-resort letter fallback styling (orb image normally covers this).
export const HERO_AVATAR_FALLBACK = 'border-none text-white';

const ORBS = [orbBlue, orbGreen, orbPurple, orbRed, orbOrange];

function hash(s: string): number {
  let h = 5381;
  for (let i = 0; i < s.length; i += 1) h = ((h << 5) + h) ^ s.charCodeAt(i);
  return Math.abs(h);
}

/** Deterministic HeroUI orb image URL for a user/channel id. */
export function avatarOrbUrl(id: string | null | undefined): string {
  return ORBS[(id ? hash(id) : 0) % ORBS.length]!;
}
